import React, { useState, useEffect } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { get, map } from 'lodash';
import { RootState } from 'modules';
import { useRecoilState } from 'recoil';
import Purchase from 'components/mentoring/Purchase';
import { getMentoringReviewsForLanding, getMentoringPassCasesForLanding } from 'libs/api/mentoring';
import { get150paymentUser } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { quizDetailPageWidthState } from 'modules/learning/recoilState';
import { TMentoringReviewsForLanding, TMentoringPassCasesForLanding } from 'modules/mentoring';
import { EMentoringTicketName, EMentoringPurchaseURLQuery } from 'modules/mentoring';
import { TUser } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { message, Col, Row, Typography, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, device, Colors, size } from 'GlobalStyles';
import blueStar from 'assets/icons/blueStar.webp';
import quoteImage from 'assets/icons/quote.webp';
import starImage from 'assets/icons/star.webp';
import titleImage from 'assets/images/banners/2.webp';
import 'animate.css/animate.min.css';

type TPaymentBtnUser = {
  [key: string]: any;
};

const { Text, Title } = Typography;
const maxWidth = CWindowWidth - 200;
const MentoringCreditPriceWrapper = styled.div`
  .title-mentoring {
    width: 100%;
    height: 380px;
    background: linear-gradient(
        0deg,
        rgba(42, 71, 83, 0.3),
        rgba(42, 71, 83, 0.3)
      ),
      url(${titleImage});
    background-size: cover;
    padding: 50px 10px;
    .ant-typography {
      width: 100%;
      color: #ffffff;
      margin: auto;
      display: block;
    }
    span.ant-typography {
      font-size: 16px;
    }
  }
  .btn-responsive {
    box-shadow: 1px 3px 8px ${Colors.grey2};
    padding: 0px !important;
    font-size: 1em;
    max-width: 100px;
    margin-bottom: 5px;
    background-color: ${SecondaryColor} !important;
    color: #fff !important;
    @media ${device.md} {
      font-size: 0.7em;
    }
  }

  .container {
    max-width: ${maxWidth}px;
    margin: auto;
    padding: 0px 3px;
  }

  .offering_header {
    font-size: 10px;
    border-bottom: 1px solid ${SecondaryColor};
    /* color: ${SecondaryColor}; */
    padding: 0px;
  }

  .offering_header_list {
    font-weight: 900;
    font-size: 10px;
    /* font-size: 7px; */
    max-width: 350px;
    margin: auto;
    text-align: center;
    .offering_title {
      font-size: 1.4em;
      font-weight: bold;
      @media screen and ${device.md} {
      font-size: 5px;
    }
    @media screen and ${device.xs} {
      font-size: 5px;
    }
      
    }
    .offering_detail {
      margin: 5px 0px;
      font-size: 1.4em;
      white-space: pre;
    }
  }

  .offering_list {
    font-weight: bold;
    color: ${PrimaryColor};
    font-size: 18px;
    font-weight:500;
    @media ${device.md} {
      font-size: 10px;
    }
    & .sub_description{
      font-size: 12px;
      font-weight:500;
      @media ${device.md} {
      font-size: 7px;
    }
    }
  }
  .service {
    color: #000;
    margin-top: 40px;
    padding: 0px 8px;
    p {
      margin-bottom: 4px;
    }
    .green-title {
      margin-top: 7px;
      font-size: 16px;
      margin-bottom: 1px;
      color: ${SecondaryColor};
    }
    .detail {
      font-size: 14px;
      margin-top: 1px;
    }
  }

  .price {
    color: ${SecondaryColor};
  }
`;

const StarWrapper = styled.div`
  .star {
    width: 14px;
    float: left;
    img {
      vertical-align: none;
    }
  }
`;
const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .item {
    margin-top: 21px;
    font-size: 16px;
    color: #14112a;
    font-weight: bold;
  }

  .footer {
    font-size: 14px;
    color: ${SecondaryColor};
    font-weight: bold;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
  color: ${PrimaryColor};

  .starIcon {
    width: 15px;
    margin-bottom: 10px;
  }

  .personIcon {
    width: 44px;
    margin: 16px 0 11px 0;
  }

  .strongText {
    color: ${SecondaryColor};
  }
`;

const SectionTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
`;

const SectionSubtitle = styled.div`
  margin-bottom: 3px;
`;

export const StarRate = ({ count }: { count: number }) => {
  return (
    <StarWrapper>
      {map(Array(count).fill(0), (v) => (
        <div className='star'>
          <img alt='star' src={`${starImage}`} />
        </div>
      ))}
    </StarWrapper>
  );
};

export const MentoringPassCase = ({ currentPage, reviewNum }: any) => {
  const getPromise = getMentoringPassCasesForLanding.bind(null, {
    params: {
      current: currentPage ? currentPage : 1,
      pageSize: reviewNum ? reviewNum : 6,
    },
  });

  const [{ data }] = useDataApi(getPromise, {
    contents: [],
  });

  return (
    // 랜딩 페이지 최신 버전

    <ReviewWrapper>
      <SectionHeader>
        <SectionTitle>합격 사례</SectionTitle>
      </SectionHeader>
      <Row gutter={[16, 16]}>
        {map(get(data, 'contents', []), (v) => (
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <img alt='' src={quoteImage} />
            <p className='item'>{get(v, 'comment')}</p>
            <Row>
              <img
                alt={get(v, 'company_logo')}
                src={get(v, 'company_logo')}
                style={{ height: '20px', marginRight: '5px' }}
              />
              <p className='footer'>{get(v, 'title')}</p>
            </Row>
          </Col>
        ))}
      </Row>
    </ReviewWrapper>

    // 이전 버전
    // <ReviewWrapper>
    //   <Row gutter={[16, 16]}>
    //     {map(get(data, 'reviews', []), (v) => (
    //       <Col xs={24} sm={24} md={8} lg={8} xl={8}>
    //         <img alt='' src={quoteImage} />
    //         <p className='item'>{get(v, 'comment')}</p>
    //         <Row>
    //           <p className='footer'>{get(v, 'title')}</p>
    //         </Row>
    //       </Col>
    //     ))}
    //   </Row>
    // </ReviewWrapper>
  );
};

const MentoringReviewTotalCount = ({ currentPage, reviewNum }: any) => {
  const getPromise = getMentoringReviewsForLanding.bind(null, {
    params: {
      current: currentPage ? currentPage : 1,
      pageSize: reviewNum ? reviewNum : 6,
    },
  });

  const [{ data }] = useDataApi(getPromise, {
    contents: [],
  });

  return (
    <SectionSubtitle>
      {get(data, 'total')}개의 실시간 멘토링 후기가 멘티들의 만족도를 증명합니다.
    </SectionSubtitle>
  );
};

export const MentoringReview = ({ currentPage, reviewNum }: any) => {
  const getPromise = getMentoringReviewsForLanding.bind(null, {
    params: {
      current: currentPage ? currentPage : 1,
      pageSize: reviewNum ? reviewNum : 6,
      is_shown: true,
    },
  });

  const [{ data }] = useDataApi(getPromise, {
    contents: [],
  });

  return (
    <ReviewWrapper>
      <SectionHeader>
        <MentoringReviewTotalCount />
        <SectionTitle>
          멘토링 <span className='strongText'>후기</span>
        </SectionTitle>
      </SectionHeader>

      <Row gutter={[16, 16]} style={{ width: '100%', marginBottom: '30px' }}>
        {map(get(data, 'contents', []), (v) => (
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <p className='item'>{get(v, 'comment')}</p>
            <div style={{ lineHeight: '32px' }}>
              <span className='footer'>멘티 {get(v, 'mentee')}</span>
              <StarRate count={get(v, 'score')} />
            </div>
          </Col>
        ))}
      </Row>
    </ReviewWrapper>
    // <ReviewWrapper>
    //   <SectionSubtitle style={{ color: 'black' }}>
    //     {get(data, 'total')}개의 실시간 멘토링 후기가 멘티들의 만족도를 증명합니다.
    //   </SectionSubtitle>
    //   <Row gutter={[16, 16]} style={{ width: '100%', marginBottom: '30px' }}>
    //     {map(get(data, 'reviews', []), (v) => (
    //       <Col xs={24} sm={24} md={8} lg={8} xl={8}>
    //         <p className='item'>{get(v, 'comment')}</p>
    //         <div style={{ lineHeight: '32px' }}>
    //           <span className='footer'>멘티 {get(v, 'mentee')}</span>
    //           <StarRate count={get(v, 'score')} />
    //         </div>
    //       </Col>
    //     ))}
    //   </Row>
    // </ReviewWrapper>
  );
};

const MentoringCreditPrice = () => {
  const history = useHistory();
  const [isOpenOrder, setIsOpenOrder] = useState(false);
  const [PageWidth, setPageWidth] = useRecoilState(quizDetailPageWidthState);
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  function handleClickInquiry() {
    message.info('우측 하단 챗봇을 통해 상담을 진행해주세요.');
  }

  const [paymentBtnUserList, setPaymentBtnUserList] = useState<Array<TPaymentBtnUser>>();

  const get150paymentUserData = async () => {
    const { success, data } = await get150paymentUser();
    if (success) {
      setPaymentBtnUserList(data);
    }
  };

  useEffect(() => {
    get150paymentUserData();
  }, []);

  return (
    <MentoringCreditPriceWrapper>
      <div className='title-mentoring'>
        <Row align='bottom' style={{ height: '100%' }}>
          <Col
            xs={{ offset: 0 }}
            sm={{ offset: 0 }}
            md={{ offset: 12 }}
            lg={{ offset: 12 }}
            xl={{ offset: 12 }}
          >
            <Title>수강권 구매</Title>
            <Text style={{ marginTop: '10px' }}>
              Career Step에서 제공하는 최고의 멘토링 서비스를 이용하세요.
            </Text>
          </Col>
        </Row>
      </div>
      <div className='container' style={{ marginTop: '80px' }}>
        <Title level={2} style={{ padding: '0px 8px' }}>
          합격사례
        </Title>
        <MentoringPassCase />
      </div>
      <div className='container' style={{ marginTop: '80px' }}>
        <Title level={2} style={{ padding: '0px 8px' }}>
          수강생 후기
        </Title>
        <MentoringReview />
      </div>

      <div className='container' style={{ marginTop: '100px', marginBottom: '100px' }}>
        <Title level={2} style={{ padding: '0px 8px' }}>
          Career Step 프로그램
        </Title>
        <div style={{ padding: '0px 8px', color: '#000', fontSize: '16px' }}>
          Career Step은 Global Consulting Firm 조인을 위한 4가지 프로그램을 운영하고 있습니다.
        </div>
        <div className='service'>
          <p className='green-title'>{EMentoringTicketName.RegularPackage}</p>
          <p className='detail'>
            컨설팅 준비의 A to Z를 Career Step 대표 멘토진의 철저한 관리하에 진행하는, MBB 타겟의 소수
            정예반입니다.
            <br />
            20년 하반기 / 21년 상반기 압도적인 MBB 합격자 수를 배출하고 있습니다.
          </p>
          <p className='green-title'>{EMentoringTicketName.TutorialPackage}</p>
          <p className='detail'>
            5회 구성으로 컨설팅 지원을 위한 기초 다지기를 목표로 합니다.
            <br />
            Career Step 대표 멘토진이 케이스 기본기와 Fit 인터뷰 스토리라인을 개인 맞춤형으로 잡아드립니다.
          </p>
          <p className='green-title'>{EMentoringTicketName.MockInterviewPackage}</p>
          <p className='detail'>
            5회 구성으로 컨설팅 지원을 위한 실전 연습을 목표로 합니다. <br />
            원하시는 분들에게는 멘토링 주제 및 멘토 구성에 대한 설계를 지원합니다.
          </p>
          <p className='green-title'>Mock 인터뷰 1회권</p>
          <p className='detail'>
            정규직 혹은 RA 지원을 위해 원하는 멘토와 인터뷰 최종 점검을 하기에 적합한 수강권입니다.
            <br />
            RA 지원을 위해서는 RA 멘토링 전담 멘토진인 Han 멘토님을 찾아주세요.
          </p>
        </div>
        <div style={{ marginTop: '100px' }}>
          {/* <Title level={2} style={{ padding: '0px 8px' }}>
            프로그램 상세 소개
          </Title> */}
          <Title level={2} style={{ padding: '0px 8px' }}>
            Offering
          </Title>
          <Row
            align='bottom'
            className='offering_header'
            gutter={[16, 16]}
            style={{ margin: '20px auto', padding: '0px' }}
          >
            <Col span={5}>
              <p className='offering_list' style={{ color: '#000', marginBottom: '0px' }}>
                프로그램
              </p>
              {/* <div className="offering_list" style={{ marginTop: '-10px' }}>
                모든 멘토링은 90분 기준입니다.
              </div> */}
              <div style={{ fontSize: '1em', lineHeight: '1.3' }}>모든 멘토링은 90분 기준입니다.</div>
            </Col>
            <Col span={2}>
              <div className='offering_header_list'>
                <div className='offering_title'>
                  밀착/전담
                  <br />
                  지원 plan 설계
                </div>
              </div>
            </Col>
            <Col span={2}>
              <div className='offering_header_list'>
                <div className='offering_title'>
                  Case 유형별
                  <br />
                  튜토리얼
                </div>
              </div>
            </Col>
            <Col span={2}>
              <div className='offering_header_list'>
                <div className='offering_title'>
                  1:1 Mock
                  <br />
                  interview
                  <br />& 피드백
                </div>
              </div>
            </Col>
            <Col span={2}>
              <div className='offering_header_list'>
                <div className='offering_title'>
                  Resume
                  <br />& Fit story
                  <br />
                  업그레이드
                </div>
              </div>
            </Col>
            <Col span={2}>
              <div className='offering_header_list'>
                <div className='offering_title'>
                  정규반
                  <br />
                  스터디
                  <br />
                  구성
                </div>
              </div>
            </Col>
            <Col span={2}>
              <div className='offering_header_list'>
                <div className='offering_title'>
                  셀프
                  <br />
                  스터디
                  <br />
                  자료제공
                </div>
              </div>
            </Col>
            <Col span={4}>
              <p
                className='offering_list'
                style={{
                  color: '#000',
                  textAlign: 'center',
                }}
              >
                가격
              </p>
            </Col>
            {/* <Col span={3}>
              <p
                style={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center'
                }}
              >
                가격
              </p>
            </Col> */}
          </Row>
          <Row align='middle' gutter={[16, 0]} style={{ margin: '10px auto', padding: '0px' }}>
            <Col span={5}>
              <p className='offering_list'>{EMentoringTicketName.RegularPackage}</p>
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={4} style={{ textAlign: 'center' }}>
              <div className='price'>상담 후 결정</div>
            </Col>
            <Col span={3} style={{ textAlign: 'center' }}>
              {currentUser &&
              paymentBtnUserList?.map((el: TPaymentBtnUser) => el.user_id).includes(currentUser.userid) ? (
                <Button
                  onClick={() =>
                    history.push(
                      `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.RegularPackage}`,
                    )
                  }
                  className='btn-responsive'
                  block={true}
                >
                  {PageWidth < size.sm ? '구매' : '수강권 구매'}
                </Button>
              ) : (
                <Button onClick={handleClickInquiry} className='btn-responsive' block={true}>
                  {PageWidth < size.sm ? '상담' : '상담하기'}
                </Button>
              )}
            </Col>
          </Row>

          <Row align='middle' gutter={[16, 0]} style={{ margin: '10px auto', padding: '0px' }}>
            <Col span={5}>
              <p className='offering_list'>
                {EMentoringTicketName.TutorialPackage}
                <p className='sub_description'>(시니어 1회권 + 주니어 4회권)</p>
              </p>
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={4} style={{ textAlign: 'center' }}>
              <div className='price'>150만원</div>
            </Col>
            <Col span={3} style={{ textAlign: 'center' }}>
              <Button
                onClick={() =>
                  history.push(
                    `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.TutorialPackage}`,
                  )
                }
                className='btn-responsive'
                block={true}
              >
                {PageWidth < size.sm ? '구매' : '수강권 구매'}
              </Button>
            </Col>
          </Row>
          <Row align='middle' gutter={[16, 0]} style={{ margin: '10px auto', padding: '0px' }}>
            <Col span={5}>
              <p className='offering_list'>
                {EMentoringTicketName.MockInterviewPackage}
                <p className='sub_description'>(시니어 3회권 + 주니어 2회권)</p>
              </p>
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={4} style={{ textAlign: 'center' }}>
              <div className='price'>150만원</div>
            </Col>
            <Col span={3} style={{ textAlign: 'center' }}>
              <Button
                onClick={() =>
                  history.push(
                    `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.MockInterviewPackage}`,
                  )
                }
                className='btn-responsive'
                block={true}
              >
                {PageWidth < size.sm ? '구매' : '수강권 구매'}
              </Button>
            </Col>
          </Row>
          <Row align='middle' gutter={[16, 0]} style={{ margin: '10px auto', padding: '0px' }}>
            <Col span={5}>
              <p className='offering_list'>Mock 인터뷰 1회권</p>
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}>
              <CheckOutlined style={{ color: `${SecondaryColor}` }} />
            </Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={2} style={{ textAlign: 'center' }}></Col>
            <Col span={4} style={{ textAlign: 'center' }}>
              <div className='price' style={{ padding: '5px 0' }}>
                시니어: 40만원
              </div>
              <div className='price' style={{ padding: '5px 0' }}>
                주니어: 25만원
              </div>
            </Col>
            <Col span={3} style={{ textAlign: 'center' }}>
              <Button
                onClick={() =>
                  history.push(
                    `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.MockInterviewSenior}`,
                  )
                }
                className='btn-responsive'
                block={true}
              >
                {PageWidth < size.sm ? '구매' : '수강권 구매'}
              </Button>
              <Button
                onClick={() =>
                  history.push(
                    `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.MockInterviewJunior}`,
                  )
                }
                className='btn-responsive'
                block={true}
              >
                {PageWidth < size.sm ? '구매' : '수강권 구매'}
              </Button>
            </Col>
          </Row>

          <Row align='middle' gutter={[16, 0]} style={{ margin: '10px auto', padding: '0px' }}>
            <Col span={5}></Col>
            <Col span={12} style={{ textAlign: 'center' }}></Col>
            {/* <Col span={4} style={{ textAlign: 'center' }}>
              <Button
                onClick={handleClickInquiry}
                className="btn-responsive"
                block={true}
              >
                상담하기
              </Button>
            </Col> */}
          </Row>
        </div>
      </div>
      <Purchase isOpenOrder={isOpenOrder} close={() => setIsOpenOrder(false)} />
    </MentoringCreditPriceWrapper>
  );
};

export default MentoringCreditPrice;
